import redact from "./_redact";

/**
 * Extract the relative internal URL from an absolute internal URL.
 *
 * Examples:
 * - https://mydomain.com/node/1 -> /node/1
 * - https://example.com/foo/bar -> https://example.com/foo/bar
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {string} getPageUrl
 *   Internal website URL.
 */
const getPageUrl = (url) => {
  const extractInternalUrl = new RegExp(
    `^(https?)://${window.location.host}`,
    "i"
  );
  return redact(url.href.replace(extractInternalUrl, ""));
};

/**
 * Extract the download file extension from the URL.
 *
 * @param {string} url
 *   The web url to check.
 *
 * @return {string} getDownloadExtension
 *   The file extension of the passed url. e.g. 'zip', 'txt'
 */
const getDownloadExtension = (url) => {
  const extractDownloadextension =
    /^.*\.(jpg|JPG|gif|GIF|doc|DOC|pdf|PDF|zip)([?#]|$)/gim;
  const extension = extractDownloadextension.exec(url.href);
  return extension === null ? "" : extension[1];
};

const sendDownloadEvent = (url) => {};

export default sendDownloadEvent;
